const termsOfServiceUpdatedAt = "07/05/2025";

export const NeighborwhoodTermsOfService = () => {
  return (
    <div>
      <h3>Terms of Service for NeighborWhood mobile application</h3>
      <br />
      Last updated: <b>{termsOfServiceUpdatedAt}</b>
      <br />
      <br />
      <p>
        <b>Essencebit SRL</b> (<b>“us”</b>, <b>“we”</b>, or <b>“our”</b>)
        operates the <b>NeighborWhood</b> mobile application (<b>“the App”</b>).
        <br />
        <br />
        <br />
        Welcome to <b>NeighborWhood</b>.<br />
        These <b>Terms of Service</b> (<b>“Terms”</b>) govern your access to and
        use of our mobile app and services (<b>“the App”</b>). By using{" "}
        <b>the App</b>, you agree to these <b>Terms</b>.
        <br />
        <h4>(1) Eligibility</h4>
        You must be at least 18 years old to use this <b>App</b>. If you are
        under the age of majority in your jurisdiction, you must have your
        parent or guardian's permission.
        <h4>(2) Use of the App</h4>
        You agree to:
        <br />- Use <b>the App</b> only for lawful purposes
        <br />
        - Respect other users and not harass, abuse, or impersonate anyone
        <br />
        - Not upload inappropriate, offensive, or illegal content
        <br />- Not attempt to reverse engineer or disrupt <b>the App</b>.
        <br />
        <h4>(3) Geolocation Features</h4>
        <b>The App</b> uses your geolocation to help connect you with other
        users nearby. By using <b>the App</b>, you consent to us collecting and
        using your geolocation data in accordance with our{" "}
        <a href="/privacy-policy/neighborwhood">
          <i>
            <b>Privacy Policy</b>
          </i>
        </a>
        .<h4>(4) Account Suspension and Termination</h4>
        We reserve the right to suspend or terminate your account at any time
        for violations of these <b>Terms</b> or misuse of <b>the App</b>.
        <br />
        <h4>(5) Intellectual Property</h4>
        All content, trademarks, and technology associated with <b>
          the App
        </b>{" "}
        are the property of <b>Essencebit</b> and protected by applicable
        intellectual property laws.
        <h4>(6) Disclaimers</h4>
        <b>The App</b> is provided <i>“as is”</i> and <i>“as available”</i>
        without warranties of any kind. We are not responsible for
        user-generated content or interactions.
        <h4>(7) Limitation of Liability</h4>
        To the maximum extent permitted by law, we shall not be liable for any
        indirect, incidental, or consequential damages arising out of your use
        of <b>the App</b>.<h4>(8) Governing Law</h4>
        These <b>Terms</b> are governed by the laws of{" "}
        <b>Republic of Moldova</b>, without regard to conflict of laws
        principles.
        <h4>(9) Changes to the Terms</h4>
        We may update these <b>Terms</b> from time to time. If we do, we'll
        notify you via <b>the App</b> or by other means.
        <h4>(10) Contact</h4>
        If you have any questions about this <b>Terms of Service</b>, please
        contact us at <a href="/">{window.location.origin}</a> by using the
        chatbot or by using the means from <b>"Contact Us"</b> section.
        <br />
        <br />
        <b>Terms of Service Changes:</b> We may update our{" "}
        <b>Terms of Service</b> from time to time. You are advised to review
        this <b>Terms of Service</b> periodically for any changes. This{" "}
        <b>Terms of Service</b> is effective as of{" "}
        <b>{termsOfServiceUpdatedAt}</b> and will remain in effect except with
        respect to any changes in its provisions in the future, which will be in
        effect immediately after being posted on this page.
      </p>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};
